// ##############################
// // // Constants
// #############################

// Redirecting route using domain, email and user Id
export const getRouteScreenPlayerUniverse = (domain, email, uid) =>
	`https://${domain}.visualid.com/admin/?e=${email}&id=${uid}`;
